/* PositiveLife smile — the brand symbol (🙂) used before and after the program name */
const SMILE_RE = /[\u{1F642}\u{1F60A}\u{263A}\u{FE0F}]/gu;

export const Smile = ({ size = 22, className = "", testId }) => (
  <span data-testid={testId} role="img" aria-label="smile" className={`inline-block leading-none select-none ${className}`} style={{ fontSize: size, lineHeight: 1 }}>🙂</span>
);

/* Program name wrapped in smiles: 🙂 PositiveLife 🙂 (existing smiles in the text are not doubled) */
export const SmileName = ({ name, size = 22, className = "", testId = "smile-name" }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-2 ${className}`}>
    <Smile size={size} /><span>{(name || "").replace(SMILE_RE, "").trim()}</span><Smile size={size} />
  </span>
);
